/**
 * Short URL Params DTO
 */
export interface ShortUrlReq {
    /**
     * URL
     */
    url: string
}

/**
 * Short URL Response DTO
 */
export interface ShortUrlRes {
    /**
     * Session ID
     */
    id: string,
    /**
     * Viewer ID
     */
    genders: Array<string>,
    /**
     * 支援的翻譯語言
     */
    languages: Array<string>,
    /**
     * 不支援的TTS語言
     */
    unsupported_tts_languages: Array<string>,
    /**
     * 會議標題
     */
    title?: string
    /**
     * 當前再線人數
     */
    size: number,
    /**
     * 最高能進入人數
     */
    capacity: number,
    /**
     * 授權種類
     */
    license: number,
}
